import Divider from "@mui/material/Divider";
import { fetchOwnerDetailsAsync } from "components/features/MyPlans/myplans.slice";
import { useTranslate } from "hooks/useTranslate";
import { uniqBy } from "lodash";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { userNameToHltId } from "utils/CommonFunctions";
import { fetchMyPlansAsync, setLoader } from "../AboveProperty/AboveProperty.slice";
import FilterButtons from "../AboveProperty/FilterButtons";
import PropertyPlansList from "../AboveProperty/PropertyPlansList";

const PropertyPlans = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const translate = useTranslate();
  const filters = useAppSelector((state) => state.aboveProperty.filters);
  const ownerList = useAppSelector((state) => state.aboveProperty.owners);
  const ownerOptions = uniqBy(ownerList, "planAccessTo");
  const { owners, status, source, functionalAreas, searchText } = filters.individualPropertyFilters.propertyPlans;
  const apiCall = async () => {
    const payload = {
      innCode: params?.inncode,
      searchText,
      searchedHltId: userNameToHltId(owners, ownerList, "planAccessTo").join(","),
      status: status.join(","),
      planSources: source.join(","),
      functionalArea: functionalAreas.join(","),
      applyOwnerFilter: owners?.length,
      includeOwners: true,
      includeOverdueMyPlansCount: true,
      includeOverdueDeadlinePlansCount: true
    };
    const props = { payload, page };
    await dispatch(fetchMyPlansAsync(props)).then((res: any) => {
      if (res?.payload?.meta?.owners?.length) {
        dispatch(
          fetchOwnerDetailsAsync({ size: res?.payload?.meta?.owners?.length, value: res?.payload?.meta?.owners })
        );
      }
    });
    dispatch(setLoader(false));
  };

  useEffect(() => {
    apiCall();
  }, [page, owners, status, source, functionalAreas, searchText]);

  useEffect(() => {
    setPage(0);
  }, [owners, status, source, functionalAreas, searchText]);

  const fetchMore = () => {
    setPage((pageNo) => pageNo + 1);
  };

  return (
    <>
      <FilterButtons
        isSourceVisible
        isStatusVisible
        isOwnersVisible
        isSearchBarVisible
        isFunctionalAreaVisible
        filterType="propertyPlans"
        searchPredefinedValue={searchText}
        optionsList={{ owner: ownerOptions }}
        parentView="individualPropertyFilters"
        searchBarPlaceHolder="Search by plan title"
      />
      <Divider />
      <PropertyPlansList fetchMore={fetchMore} label={translate("dashboard.PlanLabel")} />
    </>
  );
};

export default PropertyPlans;
